<script setup lang="ts">
import PreviousActivitiesScorecardTotalTime from '../components/scorecards/PreviousActivitiesScorecardTotalTime.vue'
import PreviousActivitiesScorecardExpenses from '../components/scorecards/PreviousActivitiesScorecardExpenses.vue'
import PreviousActivitiesScorecardDistance from '../components/scorecards/PreviousActivitiesScorecardDistance.vue'
import { Timesheets } from '../types/timers'

const props = defineProps<{
  timesheets: Timesheets
}>()
</script>
<template>
  <div class="col">
    <PreviousActivitiesScorecardTotalTime v-bind="props" />
  </div>

  <div class="col">
    <PreviousActivitiesScorecardDistance v-bind="props" />
  </div>

  <div class="col">
    <PreviousActivitiesScorecardExpenses v-bind="props" />
  </div>
</template>
